/**
 * SortSelect
 * Sort-dropdown primitives: row, label, and styled <select>.
 */

import styled from '@emotion/styled';

export const SortRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  @media (max-width: 900px) {
    display: none;
  }
`;

export const SortContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const SortLabel = styled.span`
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  line-height: ${({ theme }) => theme.lineHeights[4]}px;
  color: ${({ theme }) => theme.colors.text.primary};
  padding-right: ${({ theme }) => theme.space.md};
  white-space: nowrap;
`;

export const SortSelect = styled.select`
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  padding: ${({ theme }) => theme.space.sm} ${({ theme }) => theme.space.md};
  border: 1px solid ${({ theme }) => theme.colors.border.color};
  border-radius: ${({ theme }) => theme.radius.small};
  background: ${({ theme }) => theme.colors.background.primary};
  color: ${({ theme }) => theme.colors.text.primary};
  cursor: pointer;
  min-width: 172px;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.border.highlight};
  }
`;
